export default __webpack_public_path__ + "static/media/loc.61460d21.svg";